"use client"

import { Box, List, ListItem, Typography } from "@mui/material";
import Link from "next/link";
import { FC } from "react";
import { WebShopIcon } from "../../WebShopIcon";
import { FooterSectionListProps } from "../lib/type";
import {useAnalytics} from "@/src/components/pages/StepPage/components/useAnalytics";

export const FooterTextList: FC<FooterSectionListProps> = ({ links }) => {
    const { callAnalyticEvent } = useAnalytics();

    return (
        <List className={"flex flex-col gap-2"}>
            {links.map(({ name, href, icon, analytics }) => (
                <ListItem key={name} onClick={() => {
                    analytics && callAnalyticEvent(analytics);
                }}>
                    <Link href={href || "#"} className={"flex-center-row gap-2"}>
                        {icon && icon.name && (
                            <Box className={"w-5 h-5"}>
                                <WebShopIcon
                                    name={icon.name}
                                    fill={icon?.color ?? undefined}
                                    width={20}
                                    height={20}
                                />
                            </Box>
                        )}
                        <Typography className={"text-white"}>{name}</Typography>
                    </Link>
                </ListItem>
            ))}
        </List>
    );
};
